/* eslint-disable no-use-before-define */
import React from 'react'
import { Status, ajax } from '../../twd/twd'

export default ({sort:sort_, ts:_ts, searchParams}) => {

    const [status, setStatus] = React.useState(Status.LOADING)
    const [rows, setRows] = React.useState([])
    const [count, setCount] = React.useState(0)
    const [ts, setTs] = React.useState(_ts || 0)
    
    React.useEffect(() => {
        setStatus(Status.LOADING)
        if (ts===0) return

        ;(async ()=> {
            try {

                let p = Object.assign({
                    searchType: 'offers',
                    pageNumber: 1,
                    resultsPerPage: 400,
                    offeringType: ['ask-side'],
                    marketCheckRequired: true,
                    sort:[sort_ || {field:'askYield', direction:'DESC'}],
                }, searchParams)

                let {data} = await ajax({
                    url:'/esb/portfolio/offersearch',
                    method: 'POST',
                    params: p
                })

                let a = await data
                a.rows = a.rows
                    .map(r => {
                        let { marketCheck } = r
                        if (marketCheck==='z' || marketCheck==='Z') {
                            return null;
                        }
                        return r
                    })
                    .filter(Boolean)

                setRows(a.rows)
                setCount(a.resultSetCount)
                setStatus(Status.LOADED)
            } catch(e) {
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

    }, [ts, searchParams, sort_])

    return { status, rows, count, setRows, setTs }
}

